var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUndo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentcolor",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.48 2.424a.75.75 0 0 1 .096 1.056L4.101 5.25H9.5a4.25 4.25 0 0 1 0 8.5H8a.75.75 0 0 1 0-1.5h1.5a2.75 2.75 0 1 0 0-5.5H4.101l1.475 1.77a.75.75 0 1 1-1.152.96l-2.5-3a.75.75 0 0 1 0-.96l2.5-3a.75.75 0 0 1 1.056-.096Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUndo);
export default ForwardRef;